import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import HttpRedirect from "react-https-redirect";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <HttpRedirect>
      <App />
    </HttpRedirect>
    // </React.StrictMode>
);
